const GroupFilters = {
  membershipSuggestion: bool => ({
    name: 'suggestionCounts.total',
    operator: bool ? 'gt' : 'le',
    value: 0,
    type: 'Membership suggestions',
    displayValue: bool ? 'suggested updates' : 'no updates',
  }),

  // permissions
  globalAdministratorSudo: bool => ([
    {
      displayValue: 'global administrator/sudo',
      name: 'attributes.sudo.enabled',
      operator: 'eq',
      value: bool,
      type: 'permissions',
    },
  ]),
  globalPasswordlessSudo: bool => ({
    displayValue: 'global passwordless sudo',
    name: 'attributes.sudo.withoutPassword',
    operator: 'eq',
    value: bool,
    type: 'permissions ',
  }),
};

export default GroupFilters;
